module.exports = __webpack_public_path__ + "static/media/bellabyte-newsletter-email-marketing-768x591.b5bc6e69.jpg";